'use client';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { logError } from '@/utils/log-error';

export default function GlobalError({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    logError(error, {
      component: 'GlobalError',
      digest: error.digest
    });
  }, [error]);

  return (
    <html lang={i18n.language}>
      <body>
        <h2>{t('Error.title')}</h2>
        <button onClick={() => reset()}>{t('Error.button_label')}</button>
      </body>
    </html>
  );
}
